import * as moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Table, Space } from 'antd';
import qs from 'qs';
// style
import RecordLayoutStyle from './style.js';

// service
import { getRecords } from '../../services/user';

// component
import CustomBreadcrumb from '../../components/Breadcrumb';

import PropTypes from 'prop-types';
function RecordPage(props) {
  const [listRecord, setListRecord] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const fromDate =
    qs.parse(props?.location?.search, { ignoreQueryPrefix: true }).fromDate *
    1000;
  const toDate =
    qs.parse(props?.location?.search, { ignoreQueryPrefix: true }).toDate *
    1000;
  const userId = qs.parse(props?.location?.search, { ignoreQueryPrefix: true })
    .userId;
  const phoneNumber =
    '+' +
    qs
      .parse(props?.location?.search, {
        ignoreQueryPrefix: true,
      })
      .phoneNumber.trim();

  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    groupId: '',
    fromDate: moment(fromDate).format('YYYY-MM-DD'),
    toDate: moment(toDate).format('YYYY-MM-DD'),
  });

  useEffect(() => {
    const token = localStorage && localStorage.getItem('opentrace_token');
    if (token === null) {
      window.location.replace('/login');
      return;
    }

    setParams({
      ...params,
      groupId: props.match?.params?.groupId,
    });
  }, []);

  useEffect(() => {
    if (params.groupId) {
      getRecordList(params);
    }
  }, [params]);

  const routes = [
    {
      name: 'User Management',
      link: '/user-management',
    },
    {
      name: phoneNumber,
      link: `/user-management/${userId}?phoneNumber=${phoneNumber}`,
    },
    {
      name: 'Records',
      link: '',
    },
  ];

  const columns = [
    {
      title: 'Phone number',
      dataIndex: 'phoneNumber',
      key: 'phone',
    },
    {
      title: 'Central',
      dataIndex: 'modelC',
      key: 'modelC',
    },
    {
      title: 'Peripheral',
      dataIndex: 'modelP',
      key: 'modelP',
    },
    {
      title: 'Time',
      dataIndex: 'timestamp',
      key: 'timestamp',
      // eslint-disable-next-line react/display-name
      render: (value) => (
        // <div>
        <span>
          {value ? moment(value * 1000).format('DD-MM-YYYY HH:mm:ss') : '--'}
        </span>
        // </div>
      ),
    },
    // {
    //   title: 'End Time',
    //   dataIndex: 'contactIdValidTo',
    //   key: 'contactIdValidTo',
    //   // eslint-disable-next-line react/display-name
    //   render: (value) => (
    //     // <div>
    //       <span>
    //        { value ? moment(value * 1000).format('DD-MM-YYYY HH:mm:ss') : "--"}
    //       </span>
    //     // </div>
    //   )
    // },
  ];

  async function getRecordList(params) {
    setLoading(true);
    let res = await getRecords({
      ...params,
    });

    // let convertData = [];
    if (res?.docs?.length) {
      let i = 0;

      res?.docs?.forEach((e) => {
        ++i;
        e.key = i;
        e.phoneNumber = e.contact?.phoneNumber || '';
      });
    }

    setListRecord(res);
    setLoading(false);
  }

  function handleChangePageSize(pagination) {
    setParams({
      ...params,
      page: pagination.current,
    });
  }

  return (
    <>
      {/* <ModalRecord visible={isShow} userId={userId} onCancel={handleCancel} /> */}
      <RecordLayoutStyle>
        <CustomBreadcrumb routes={routes} />
        <Space className="spaceRecordDate">
          <h4>
            From {moment(fromDate).format('DD-MM-YYYY HH:mm:ss')} to{' '}
            {moment(toDate).format('DD-MM-YYYY HH:mm:ss')}
          </h4>
        </Space>
        <Table
          // pagination={true}
          dataSource={listRecord.docs}
          columns={columns}
          loading={isLoading}
          onChange={handleChangePageSize}
          pagination={{
            pageSize: params && params.limit,
            total: listRecord && listRecord.totalDocs,
            defaultPageSize: params && params.limit,
            current: params && params.page,
            defaultCurrent: params && params.page,
            // showSizeChanger: false,
            // showLessItems: true
          }}
        />
      </RecordLayoutStyle>
    </>
  );
}

RecordPage.propTypes = {
  match: PropTypes.any,
  location: PropTypes.any,
};

export default RecordPage;
